// extracted by mini-css-extract-plugin
module.exports = {"profileContentBox":"Home_profileContentBox__190TE","profileContent":"Home_profileContent__1W0DG","profileSetting":"Home_profileSetting__2YtoC"};